import { __awaiter, __rest } from "tslib";
export class EdgeCommand {
    constructor({ model }) {
        this.execute = (command, args) => __awaiter(this, void 0, void 0, function* () {
            return this[command](args);
        });
        this.model = model;
    }
    ADD_EDGE(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges: [...edges, payload],
                    groups,
                    nodes,
                };
            }, res);
        });
    }
    DELETE_EDGE(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges: edges === null || edges === void 0 ? void 0 : edges.filter(edge => payload !== edge.id),
                    groups,
                    nodes,
                };
            }, res);
        });
    }
    BATCH_ADD_EDGES(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges: [...edges, ...payload],
                    groups,
                    nodes,
                };
            }, res);
        });
    }
    BATCH_DELETE_EDGES(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges: edges === null || edges === void 0 ? void 0 : edges.filter(edge => !(payload === null || payload === void 0 ? void 0 : payload.includes(edge.id))),
                    groups,
                    nodes,
                };
            }, res);
        });
    }
    UPDATE_CONNECTION_OF_EDGE(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes, edges, groups }) => {
                return {
                    edges: edges.map((edge) => {
                        if (edge.id === payload.id) {
                            return Object.assign(Object.assign({}, edge), payload);
                        }
                        else {
                            return edge;
                        }
                    }),
                    groups,
                    nodes,
                };
            }, res);
        });
    }
}
//# sourceMappingURL=index.js.map